"use strict";

var _regeneratorRuntime = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionManager = void 0;

var eth_block_tracker_1 = require("eth-block-tracker");

var createSubscriptionManager = require("eth-json-rpc-filters/subscriptionManager");

var noop = function noop() {};

var SubscriptionManager = /*#__PURE__*/function () {
  function SubscriptionManager(provider) {
    _classCallCheck(this, SubscriptionManager);

    var blockTracker = new eth_block_tracker_1.PollingBlockTracker({
      provider: provider,
      pollingInterval: 15 * 1000,
      setSkipCacheFlag: true
    });

    var _createSubscriptionMa = createSubscriptionManager({
      blockTracker: blockTracker,
      provider: provider
    }),
        events = _createSubscriptionMa.events,
        middleware = _createSubscriptionMa.middleware;

    this.events = events;
    this.subscriptionMiddleware = middleware;
  }

  _createClass(SubscriptionManager, [{
    key: "handleRequest",
    value: function () {
      var _handleRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};
                _context.next = 3;
                return this.subscriptionMiddleware(request, result, noop, noop);

              case 3:
                return _context.abrupt("return", result);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleRequest(_x) {
        return _handleRequest.apply(this, arguments);
      }

      return handleRequest;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      this.subscriptionMiddleware.destroy();
    }
  }]);

  return SubscriptionManager;
}();

exports.SubscriptionManager = SubscriptionManager;